import React from 'react';
import styles from './style.module.scss';

export default ({ children, container }) => {
  return <div className={`${styles['footer']} ${container ? styles['container'] : ''}`}>{children}</div>;
};
